import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/lib/supabase';

let clientPromise: Promise<SupabaseClient<Database>> | null = null;

/** Lazy-load Supabase client (eigen chunk, niet op elke pagina nodig). */
export function getSupabaseClient(): Promise<SupabaseClient<Database>> {
  if (!clientPromise) {
    clientPromise = import('@/lib/supabase').then((module) => module.supabase);
  }
  return clientPromise;
}
